const axios = require("axios");

var createNguyenVongs = ({ nguyenvongs, thiSinhId, dotDangKyId }) => {
	let methods = [];
	nguyenvongs.forEach((item, index) => {
		methods.push(
			axios.post(
				`${process.env.VUE_APP_API}${process.env.VUE_APP_NGUYENVONG}`,
				{
					thiSinhId: thiSinhId,
					nganhId: item.nganhId,
					toHopId: item.toHopId,
					diem1: item.diem1,
					diem2: item.diem2,
					diem3: item.diem3,
					diemXetTuyen: item.diemXetTuyen,
					thuTu: index + 1,
					dotDangKyId: dotDangKyId,
				},
			),
		);
	});
	return axios
		.all(methods)
		.then(
			axios.spread((...responses) => {
				return responses;
			}),
		)
		.catch((error) => {
			return error.response;
		});
};

var getNguyenVongsByThiSinhId = (thiSinhId) => {
	return axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_NGUYENVONG}${process.env.VUE_APP_NGUYENVONG_TS}/${thiSinhId}`,
		)
		.then((response) => response)
		.catch((error) => error.response);
};

var deleteNguyenVongs = (nguyenvongs) => {
	let methods = [];
	nguyenvongs.forEach((item) => {
		methods.push(
			axios.delete(
				`${process.env.VUE_APP_API}${process.env.VUE_APP_NGUYENVONG}/${item.nguyenVongId}`,
			),
		);
	});
	return axios
		.all(methods)
		.then(
			axios.spread((...responses) => {
				return responses;
			}),
		)
		.catch((error) => {
			return error.response;
		});
};

var getNguyenVongsByThiSinhIdAndDotId = (thiSinhId, dotDangKyId) => {
	return axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_NGUYENVONG}${process.env.VUE_APP_FINDTHISINH}`,
			{
				params: {
					thiSinhId: thiSinhId,
					dotDangKyId: dotDangKyId,
				},
			},
		)
		.then((response) => response)
		.catch((error) => error.response);
};

export const NguyenVongService = {
	createNguyenVongs,
	getNguyenVongsByThiSinhId,
	deleteNguyenVongs,
	getNguyenVongsByThiSinhIdAndDotId,
};
